<template>
  <w-popup-show :state="state" @handleClose="handleClose">
    <div slot="content" class="tip-content">
      <div class="tip-header flex-between">
        <span class="tip-title headline">小贴士</span>
        <span class="iconfont iconx" @click="handleClose"/>
      </div>
      <div class="tip-content">
        <cube-scroll :data="faqs">
          <div class="tip-container">
            <p class="tip-desc-area">来自名企 HR 的专业建议，帮你解答写简历中的各种问题。</p>
            <div class="tip-item" v-for="(item, index) in faqs" :key="index">
              <p class="flex-between faq-title" @click="changeFaqStatus(index)">
                <span>{{ item.headerline }}</span>
                <span class="iconfont" :class="tipStatus[index] ? 'iconchevron-up' : 'iconchevron-down'"/>
              </p>
              <p class="tip-data" v-show="tipStatus[index]" v-html="item.desc"/>
            </div>
          </div>
        </cube-scroll>
      </div>
    </div>
  </w-popup-show>
</template>

<script>
	import WPopupShow from '@/components/global/w-popup-show'
	import { mapState } from 'vuex'

	export default {
		name: 'cv-tips',
		props: {
			state: {
				type: Boolean,
				default: false
			},
			tipData: {
				type: Array,
				default: null
			}
		},
		data () {
			return {
				tipStatus: []
			}
		},
		mounted () {
		},
		computed: {
			...mapState('cv', [ 'faqs' ]),
		},
		watch: {
			state (val) {
				if (val && this.tipData instanceof Array) {
					this.tipStatus = new Array(this.faqs.length).fill(false)
					this.tipStatus[0] = true
				}
			}
		},
		components: {
			WPopupShow,
		},
		methods: {
			handleClose () {
				this.$emit('handleClose')
			},
			changeFaqStatus (index) {
				this.tipStatus[index] = !this.tipStatus[index]
				this.$forceUpdate()
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  .tip-content {
    width: 100vw;
    height: 80vh;
    .tip-header {
      height: 54px;
      padding: 0 26px;
      border-bottom: 1px solid #E3E3E3;
      .iconfont {
        color: #9c9c9c;
        font-size: 18px;
      }
    }
    .tip-content {
      height: calc(80vh - 54px);
      .tip-container {
        padding: 20px 26px 32px;
        .tip-desc-area {
          color: $color-dark-gray;
          padding: 9px 18px;
          line-height: 20px;
          background-color: #f9f9f9;
          border-radius: 4px;
          margin-bottom: 24px;
        }
        .tip-item {
          margin-bottom: 28px;
          .faq-title {
            margin-bottom: 16px;
            color: $color-title;
            align-items: flex-start;
            line-height: 18px;
            .iconfont {
              color: $color-light-gray;
              font-weight: bold;
            }
          }
          .tip-data /deep/ * {
            color: #9C9C9C;
            line-height: 22px;
          }
          .tip-data /deep/ li {
            list-style: inside;
          }
        }
      }
    }
  }
</style>
